"use client";
import { useEffect, useState } from "react";
import { getTranslation } from "@/i18n/get-translation";
import { ICategory, ICategoryResponse } from "@/types/category.type";
interface INavigation {
  id: number;
  name: string;
  href: string;
}

interface IInnerSubCategories {
  locale: string;
  categories: ICategoryResponse;
  handleSelect: (data: ICategory) => void;
  selected: string;
}

export default function InnerSubCategories({
  locale,
  categories,
  selected,
  handleSelect,
}: IInnerSubCategories) {
  const t = getTranslation(locale, "innerSubCategories");
  const all: ICategory = {
    id: -1,
    attributes: {
      name: t("all"),
      description: null,
      createdAt: new Date().toString(),
      updatedAt: new Date().toString(),
      publishedAt: new Date().toString(),
      localizations: { data: [] },
    },
  };
  return (
    <div className="border-0 mb-0 w-full flex justify-center pl-20 max-md:pl-7 md:py-8 py-6 md:mt-0 mt-[9.5rem] relative">
      <ul
        className="flex list-none pl-0 flex-row flex-auto gap-4 overflow-auto customOverflow pr-2"
        role="tablist"
        data-te-nav-ref
      >
        {[all, ...categories.data].map((item: ICategory) => (
          <li role="presentation" key={item.id}>
            <button
              type="button"
              className={`${
                selected === item.attributes.name
                  ? "bg-primary-700 text-white"
                  : "bg-primary-500 text-primary-800"
              } block lg:min-w-[10rem] min-w-[7rem] w-full rounded-xl hover:bg-primary-700 hover:text-white px-4 lg:py-[1.125rem] py-[.825rem] xl:text-xl lg:text-lg text-base font-medium whitespace-nowrap`}
              onClick={() => handleSelect(item)}
            >
              {item.attributes.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
